import React, { useState, useEffect, Fragment } from 'react';
import {
  IconButton,
  Grid,
  Table,
  TableContainer,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
  Paper,
  Popper,
  TableSortLabel,
  NativeSelect,
  ClickAwayListener,
  Menu,
  MenuItem,
  FormControl,
  Select,
  Radio,
  RadioGroup,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import jMoment from 'moment-jalaali';
import { StylesProvider, withStyles } from '@material-ui/core/styles';
import Icon from '@mdi/react';
import {
  mdiDotsVertical,
  mdiArrowDown,
  mdiArrowUp,
  mdiCloseCircleOutline,
} from '@mdi/js';
import Pagination from '@material-ui/lab/Pagination';

import RenderFilter from './tableListDaynamicFilter';
import {
  translate,
  removeEmptyValueObject,
} from './helpers';
// import RenderFilter from './tableListDaynamicFilterHookForm';

import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

type Item = {
  count: number;
  productId: number;
  orderId: number;
  volume: number;
  weight: number;
  productName: string;
  code: string;
  status: string;
  variantId: number;
  variantCode?: string;
};
type Order = {
  postTrackingCode: string;
  bundleId?: number;
  created?: string;
  customerName?: string;
  barcode?: string;
  postCity?: string;
  customerProvince?: string;
  customerCity?: string;
  customerPhoneNumber?: string;
  customerMobileNumber?: string;
  partnerName: string;
  partnerId?: number;
  fulfillmentLineId?: number;
  postPrice?: number;
  totalPrice?: number;
  customerAddress?: string;
  deliveryDate?: string;
  deliveryEndTime?: string;
  deliveryStartTime?: string;
  sourceName?: string;
  id: number;
  items: Item[];
  orders?: Order[];
  priority?: number;
  rubikaId?: string;
  sourceId?: number;

  updated: string;
  vehicleId: number;
  trackingCode?: string;
  customerNationalCode?: string;
  registrationDate: string;
  customerZipCode?: string;
  fulfillmentWarehouseName?: string;
  fulfillmentWarehouseAddress?: string;
  fulfillmentWarehouseId?: number;
  centerId?: number;
  deliveryType: string;
  weight: number;
  postWeight: number;
  length: number;
  height: number;
  width: number;
  orderType: string;
  description: string;
  orderPackages?: any;
  customerLat?: number;
  customerLon?: number;
};
type Orders = Order[];
type Data = Order;
type Props = {
  data: any;
};
type Ord = 'asc' | 'desc';
type TableBuilder = {
  removeFilterHandler: () => void;
  sizeChanged: () => void;
  pageChanged: () => void;
  count: number;
  data: any;
  head: any;
  filterVal: any;
  onFilterVal: () => void;
  filterLabelTranslator: any;
  checkbox: boolean;
  setSelectedId: () => void;
}
interface filter {
  id: keyof Data;
  label: string;
}

const StyledTableCell = withStyles((theme: Theme) =>
  createStyles({
    head: {
      backgroundColor: theme.palette.primary.main,
      color: theme.palette.common.white,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      '@media (max-width: 768px)': {
        fontSize: 10,
      },
    },
    body: {
      fontSize: 14,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',

    },
  })
)(TableCell);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      '& .MuiTableCell-paddingCheckbox': {
        padding: '0 0 0 5px',
      },
    },
    icon: {
      margin: 'auto 10px auto 0px',
    },
    columnText: {
      padding: '0 10px 0 0',
      color: 'white',
    },
    // Fully visible for active icons
    activeSortIcon: {
      opacity: 1,
      color: `${theme.palette.secondary.main}!important`,
    },
    // Half visible for inactive icons
    inactiveSortIcon: {
      opacity: 0.4,
    },
    changStatusIcon: {
      marginRight: '10px',
      position: 'absolute',
    },
    paper: {
      width: '100%',
    },
    loading: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      height: '50vh',
      alignSelf: 'center',
      justifyContent: 'center',
      background: '#ccc',
    },
    pagination: {
      // marginTop: theme.spacing(1),
    },
    searchBox: {
      display: 'flex',
      position: 'relative',
      backgroundColor: theme.palette.common.white,
      borderRadius: '4px',
      padding: '10px 0',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
    },
    input: {
      display: 'flex',
      marginLeft: theme.spacing(1),
      flex: 2,
      '@media (max-width: 768px)': {
        fontSize: '12px',
      },
    },
    optionsMenu: {
      // borderRadius: '50x',
      // padding: '5px 5px !important',
      // backgroundColor: 'red !important',
      // outline: 'none',
      // '-webkit-appearance': 'none !important' /* Safari and Chrome */,
      // '-moz-appearance': 'none !important' /* Firefox */,
      // '&:hover': {
      //   backgroundColor: 'green !important',
      //   color: 'white !important',
      // },
      // cursor: 'pointer !important',
    },
    cancelFilter: {
      borderRadius: '30px',
      backgroundColor: 'red',
    },
    iconButton: {
      padding: 8,
      marginRight: '10px',
      position: 'relative',
      '&:before': {
        content: '""',
        position: 'absolute',
        width: '1px',
        height: '36px',
        top: '4px',
        left: '-9px',
        backgroundColor: '#EDF1F4',
      },
    },
    textArea: {
      width: '100%',
    },
    filterBox: {
      position: 'absolute',
      backgroundColor: '#fff',
      width: '100%',
      marginTop: '30px',
      top: '47px',
      right: 0,
      borderRadius: '0  0 4px  4px',
      padding: '16px 16px',
      boxSizing: 'border-box',
      boxShadow: '0px 2px 4px 1px rgba(0,0,0,0.1)',
      zIndex: 10,
    },
    filterOpen: {
      display: 'block',
    },
    filterClose: {
      display: 'none',
    },
    paginationBox: {
      display: 'flex',
    },
    selectSize: {
      width: '35px',
    },
    subtitle: {
      fontSize: '14px',
      fontWeight: 500,
      color: '#8A8A8A',
    },
    magnifyIcon: {
      transform: 'rotate(-90deg)',
    },
    container: {
      maxHeight: 650,
      borderRadius: '4px',
    },
    // Cancel Dialog
    cancelIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),

      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.error.main,
      },
    },
    cancelTitle: {
      fontSize: '16px',
      fontWeight: 500,
      textAlign: 'justify',
      lineHeight: 2,
      marginBottom: theme.spacing(3),
    },
    actionsBox: {
      paddingTop: theme.spacing(2),
      paddingRight: theme.spacing(3),
      paddingLeft: theme.spacing(3),
    },
    editIcon: {
      textAlign: 'center',
      position: 'relative',
      paddingLeft: theme.spacing(8),
      marginBottom: theme.spacing(7),
      '&::before': {
        content: '""',
        position: 'absolute',
        width: '100px',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%,-50%)',
        height: '100px',
        borderRadius: '50%',
        opacity: '0.2',
        backgroundColor: theme.palette.blue.main,
      },
    },
    changStatusBox: {
      display: 'flex',
      textAlign: 'left',

      fontWeight: 400,
      fontSize: '14px',
    },
    renderValue: {
      paddingLeft: '32px',
    },
    radioGroup: {
      margin: '-8px 0',
    },
    radioGroupItem: {
      borderBottom: '1px solid #D8D8D8',
      marginRight: '-8px',
      padding: '8px 16px',
      '&:last-child': {
        borderBottom: '0px',
      },
    },
    btnBox: {
      display: 'flex',
      flexDirection: 'row-reverse',
      width: '100%',
      '@media (max-width: 768px)': {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
      },
    },
  })
);

function stableSort<T>(array: T[], comparator: (a: T, b: T) => number) {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map(el => el[0]);
}

function getComparator<Key extends keyof any>(
  order: Ord,
  orderBy: Key
): (
  a: { [key in Key]: number | string },
  b: { [key in Key]: number | string }
) => number {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}


const Helper = (props: TableBuilder) => {
  // const authContext = useContext(AuthContext);
  const [order, setOrder] = React.useState<Ord>('desc');
  const [orderBy, setOrderBy] = React.useState('id');
  const [openMenu, setOpenMenu] = useState<boolean>(false);
  const [openSize, setOpenSize] = useState<boolean>(false);
  const [searchBy, setSearchBy] = useState<string>('id');
  const [filtersValues, setFiltersValues] = useState({ ...props.filterVal });
  const [type, setType] = useState({ operator: '' });
  const [anchorEl, setAnchorEl] = useState(null);
  const [filterIconShow, setFilterIconShow] = useState({});
  const [selected, setSelected] = React.useState<string[]>([]);

  const removeFilterHandler = (fieldName: any) => {
    const moz = { ...props.filterVal };
    delete moz[fieldName];
    setFiltersValues(moz);
    props.removeFilterHandler(fieldName);
  };
  const searchFilters = () => {
    let filter = { ...props.filterVal };
    delete filter.page;
    delete filter.size;
    delete filter.sort;
    return filter;
  };
  const handleSelectAllClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = props.data.map((n: any) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };
  const handleClick = (event: React.MouseEvent<unknown>, id: string) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected: string[] = [];
    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1)
      );
    }

    setSelected(newSelected);
  };
  const classes = useStyles();

  useEffect(() => {
    props.setSelectedId(selected);
  }, [selected]);
  const fieldTranslator = (val, translateType) => {
    let translated;
    translateType === 'Order'
      ? (translated = translate(val, 'order'))
      : translateType === 'UserRole'
        ? (translated = translate(val, 'user'))
        : translateType === 'Category'
          ? (translated = val)
          : translateType === 'CenterStatus'
            ? (translated = translate(val, 'center'))
            : translateType === 'ParcelsStatus'
              ? (translated = translate(val, 'parcel'))
              : translateType === 'FleetType'
                ? (translated = translate(val, 'fleet'))
                : translateType === 'SendDeliveryType'
                  ? (translated = translate(val))
                  : (translated = val);
    return translated;
  };
  const dateTypeTranslator = (dateType: any) => {
    const status = {
      '=': 'equals',
      '>=': 'greaterThanOrEqual',
      '<=': 'lessThanOrEqual',
      '>': 'greaterThan',
      '<': 'lessThan',
    };
    return status[dateType];
  };
  const selectChangeHandler = (event: any) => {
    if (
      event.target.value == '=' ||
      event.target.value == '>=' ||
      event.target.value == '<=' ||
      event.target.value == '>' ||
      event.target.value == '<'
    ) {
      const val = dateTypeTranslator(event.target.value);
      const name = event.target.name;
      setType({
        ...type,
        [name]: val,
      });
    } else {
      const name = event.target.name;
      setType({
        ...type,
        [name]: event.target.value,
      });
    }
  };
  const handleClickAway = (e: any) => {
    if (
      e.target.getAttribute('dir') !== 'rtl' &&
      e.target.getAttribute('type') !== 'checkbox' &&
      e.target.getAttribute('class') !== 'PrivateSwitchBase-input-73' &&
      e.target.getAttribute('class') !==
      'MuiTypography-root MuiListItemText-primary MuiTypography-body1 MuiTypography-displayBlock' &&
      e.target.getAttribute('aria-hidden') !== 'true'
    )
      setOpenMenu(false);
  };

  const pageSizeCloseHandler = () => {
    setOpenSize(false);
  };
  const searchBoxOpen = (prop: any) => (event: React.MouseEvent<unknown>) => {
    setAnchorEl(event.currentTarget);
    setOpenMenu(true);
    setSearchBy(prop);
  };

  const createSortHandler =
    (property: any) => (event: React.MouseEvent<unknown>) => {
      handleRequestSort(event, property);
    };
  const changeSizePageHandler = (
    event: React.ChangeEvent<{ value: unknown }>
  ) => {
    setFiltersValues({ ...filtersValues, page: 0, size: event.target.value });
    props.sizeChanged({
      ...filtersValues,
      page: 0,
      size: event.target.value,
      sort: 'id,desc',
    });
  };
  const changePageHandler = (
    event: React.ChangeEvent<unknown>,
    page: number
  ) => {
    setFiltersValues({ ...filtersValues, page: page - 1 });
    props.pageChanged({ ...filtersValues, page: page - 1 });
  };

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: keyof Data
  ) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  const isSelected = (id: string) => selected.indexOf(id) !== -1;
  return (
    <StylesProvider injectFirst>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <div className={classes.root}>
            <Paper className={classes.paper}>
              <TableContainer className={classes.container}>
                <Table
                  size='small'
                >
                  <TableHead>
                    <ClickAwayListener onClickAway={handleClickAway}>
                      <TableRow>
                        {props.checkbox && (
                          <StyledTableCell padding="checkbox">
                            <Checkbox
                              indeterminate={
                                selected.length > 0 &&
                                selected.length < props.data.length
                              }
                              checked={
                                props.data.length > 0 &&
                                selected.length === props.data.length
                              }
                              onChange={handleSelectAllClick}
                              inputProps={{ 'aria-label': 'select all desserts' }}
                              style={{ color: '#fff' }}
                            />
                          </StyledTableCell>
                        )}
                        {props?.head.headCells.map(
                          (filter: any, index: number) => {
                            for (
                              let i = 0;
                              i < Object.keys(searchFilters()).length;
                              i++
                            ) {
                              const checkFilter = Object.keys(searchFilters())[
                                i
                              ].includes(filter.id);
                              let findFilter;
                              if (checkFilter) {
                                findFilter = Object.keys(filterIconShow).find(
                                  filterIcon => {
                                    return filterIcon === filter.id;
                                  }
                                );
                              } else {
                                findFilter = null;
                              }
                              if (
                                Object.keys(searchFilters())[i].includes(
                                  filter.id
                                ) &&
                                findFilter == undefined &&
                                checkFilter
                              ) {
                                let filtersShuldShow = {
                                  ...filterIconShow,
                                  [filter.id]: true,
                                };
                                setFilterIconShow(filtersShuldShow);
                              }
                            }

                            return (
                              <StyledTableCell
                                key={filter.id}
                                align="center"
                                sortDirection={
                                  orderBy === filter.id ? order : false
                                }
                                data-cy={filter.id}
                              >
                                <IconButton
                                  onClick={searchBoxOpen(filter.id)}
                                  style={{ padding: ' 10px 0' }}
                                >
                                  {' '}
                                  <Icon
                                    color={
                                      filterIconShow[filter.id]
                                        ? 'red'
                                        : 'secondary'
                                    }
                                    path={
                                      filterIconShow[filter.id]
                                        ? mdiCloseCircleOutline
                                        : mdiDotsVertical
                                    }
                                    size={1}
                                    className={classes.icon}
                                  />{' '}
                                </IconButton>{' '}
                                <TableSortLabel
                                  onClick={createSortHandler(filter.id)}
                                  direction={
                                    orderBy === filter.id ? order : 'asc'
                                  }
                                  hideSortIcon={false}
                                  style={{ marginLeft: '0px' }}
                                  classes={{
                                    // Override with the active class if this is the selected column or inactive otherwise
                                    icon:
                                      orderBy === filter.id
                                        ? classes.inactiveSortIcon
                                        : classes.activeSortIcon,
                                  }}
                                  IconComponent={() => (
                                    <Icon
                                      path={
                                        orderBy === filter.id &&
                                          order === 'desc'
                                          ? mdiArrowUp
                                          : mdiArrowDown
                                      }
                                      size={0.7}
                                      className={
                                        orderBy === filter.id
                                          ? classes.activeSortIcon
                                          : classes.inactiveSortIcon
                                      }
                                    />
                                  )}
                                >
                                  <span className={classes.columnText}>
                                    {filter.label}
                                  </span>{' '}
                                </TableSortLabel>{' '}
                                {searchBy === filter.id && openMenu ? (
                                  <Popper
                                    open={openMenu}
                                    anchorEl={anchorEl}
                                    keepMounted
                                    style={{ maxHeight: 48 * 4.5, width: '20ch' }}
                                    placement="bottom-end"
                                  >
                                    <Paper
                                      style={{
                                        width: '300px',
                                        backgroundColor: '#FAECD2',
                                      }}
                                    >
                                      <Grid
                                        container
                                        style={{ margin: '0px  5px' }}
                                      >
                                        {searchBy === filter.id && openMenu ? (
                                          <Grid
                                            item
                                            xs={4}
                                            sm={4}
                                            style={{
                                              margin: '20px 20px 5px 10px',
                                            }}
                                          >
                                            <RenderFilter
                                              type={type}
                                              filterVals={props.filterVal}
                                              filters={[
                                                props.head.headCells[index],
                                              ]}
                                              onFilter={(filtervalues: any) => {
                                                setFiltersValues({
                                                  ...filtervalues,
                                                  page: 0,
                                                  size: 10,
                                                  sort: orderBy + order,
                                                });
                                                props.onFilterValue(
                                                  filtervalues
                                                );
                                              }}
                                            />
                                            {/* </div> */}
                                          </Grid>
                                        ) : null}{' '}
                                        <Grid
                                          item
                                          xs={4}
                                          sm={4}
                                          style={{ margin: '35px 50px 5px 0px' }}
                                        >
                                          <NativeSelect
                                            value={type.operator}
                                            onChange={selectChangeHandler}
                                            inputProps={{
                                              name: 'operator',
                                              id: 'age-native-helper',
                                            }}
                                            style={{
                                              textAlign: 'center',
                                              alignItems: 'center',
                                              justifyContent: 'center',
                                            }}
                                          >
                                            {filter.type == 'date-picker' ? (
                                              <Fragment>
                                                <option
                                                  value=""
                                                  disabled
                                                  selected
                                                >
                                                  {' '}
                                                  -- select --
                                                </option>
                                                <option
                                                  value="contains"
                                                  className={
                                                    classes.optionsMenu
                                                  }
                                                  disabled
                                                ></option>
                                                <option
                                                  value="greaterThanOrEqual"
                                                  className={
                                                    classes.optionsMenu
                                                  }
                                                >
                                                  {'=<'}
                                                </option>
                                                <option
                                                  value="lessThanOrEqual"
                                                  className={
                                                    classes.optionsMenu
                                                  }
                                                >
                                                  {'=>'}
                                                </option>
                                                <option
                                                  value="lessThan"
                                                  className={
                                                    classes.optionsMenu
                                                  }
                                                >
                                                  {'<'}
                                                </option>
                                                <option
                                                  value="greaterThan"
                                                  className={
                                                    classes.optionsMenu
                                                  }
                                                >
                                                  {'>'}
                                                </option>
                                                <option
                                                  className={
                                                    classes.optionsMenu
                                                  }
                                                  value="equals"
                                                >
                                                  =
                                                </option>
                                              </Fragment>
                                            ) : filter.type == 'checkbox' ? (
                                              <Fragment>
                                                <option
                                                  value=""
                                                  disabled
                                                  selected
                                                >
                                                  {' '}
                                                  -- select --
                                                </option>
                                                <option
                                                  value="in"
                                                  className={
                                                    classes.optionsMenu
                                                  }
                                                >
                                                  in
                                                </option>
                                                <option
                                                  className={
                                                    classes.optionsMenu
                                                  }
                                                  disabled={
                                                    props.head.headCells[index]
                                                      .type != 'checkbox'
                                                  }
                                                  value="notIn"
                                                >
                                                  notIn
                                                </option>
                                              </Fragment>
                                            ) : (
                                              <Fragment>
                                                <option
                                                  value=""
                                                  disabled
                                                  selected
                                                  style={{
                                                    textAlign: 'center',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    marginRight: '50px',
                                                  }}
                                                >
                                                  {' '}
                                                  -- select --
                                                </option>
                                                <option
                                                  value="contains"
                                                  className={
                                                    classes.optionsMenu
                                                  }
                                                >
                                                  contains
                                                </option>
                                                <option
                                                  className={
                                                    classes.optionsMenu
                                                  }
                                                  disabled={
                                                    props.head.headCells[index]
                                                      .type != 'input'
                                                  }
                                                  value="equals"
                                                >
                                                  equals
                                                </option>
                                              </Fragment>
                                            )}
                                          </NativeSelect>
                                        </Grid>
                                      </Grid>
                                      <Grid
                                        container
                                        alignItems="center"
                                        justify="space-around"
                                        direction="column"
                                      >
                                        {Object.entries(searchFilters()).map(
                                          (searchFilter, sizess) => {
                                            return (
                                              searchFilter[0].includes(
                                                filter.id
                                              ) &&
                                              filter.filter != 'not' && (
                                                <Grid item>
                                                  {' '}
                                                  <IconButton
                                                    onClick={() =>
                                                      removeFilterHandler(
                                                        searchFilter[0]
                                                      )
                                                    }
                                                  >
                                                    {' '}
                                                    <Icon
                                                      color="red"
                                                      path={
                                                        mdiCloseCircleOutline
                                                      }
                                                      size={1}
                                                    // className={classes.cancelFilter}
                                                    // className={classes.icon}
                                                    />{' '}
                                                  </IconButton>{' '}
                                                  <span>
                                                    {' '}
                                                    {props.filterLabelTranslator(
                                                      searchFilter[0]
                                                    )}{' '}
                                                  </span>
                                                  <span>
                                                    {removeEmptyValueObject(
                                                      searchFilter[1]
                                                    )}
                                                  </span>{' '}
                                                </Grid>
                                              )
                                            );
                                          }
                                        )}
                                      </Grid>
                                    </Paper>
                                  </Popper>
                                ) : null}
                              </StyledTableCell>
                            );
                          }
                        )}
                        {props.children && <StyledTableCell></StyledTableCell>}
                      </TableRow>
                    </ClickAwayListener>
                  </TableHead>
                  <TableBody>
                    {stableSort(props.data, getComparator(order, orderBy))
                      ?.slice()
                      .map((dat: any, index2: number) => {
                        const isItemSelected = isSelected(dat.id);
                        const labelId = `enhanced-table-checkbox-${index2}`;
                        let color = '';
                        let backgroundColor = '';

                        switch (true) {
                          case dat.status === 'UNLOADED' ||
                            dat.status === 'PACKAGED' ||
                            dat.status === 'BUNDLED' ||
                            dat.status === 'ASSIGNED':
                            backgroundColor = '#d1e8fa';
                            color = '#283c74';
                            break;
                          case dat.status === 'CANCELLED' ||
                            dat.status === 'RETURNING':
                            backgroundColor = '#fdd1cc';
                            color = '#611a15';
                            break;
                          case dat.status === 'LOADED' ||
                            dat.status === 'DELIVERED':
                            backgroundColor = '#d7fcd7';
                            color = '#1e4659';
                            break;
                        }
                        return (
                          <TableRow key={index2 + 1 * 10}>
                            {props.checkbox && (
                              <StyledTableCell padding="checkbox">
                                <Checkbox
                                  key={index2 + 5 * 123456}
                                  onClick={event => handleClick(event, dat.id)}
                                  checked={isItemSelected}
                                  inputProps={{ 'aria-labelledby': labelId }}
                                />
                              </StyledTableCell>
                            )}
                            {props.head.headCells.map(
                              (filter: any, index3: number) => {
                                return (
                                  <Fragment>
                                    <StyledTableCell
                                      scope="row"
                                      align="center"
                                      style={{ color: color }}
                                      key={index3 + 1 * 100}
                                    >
                                      {filter.type == 'date-picker' ? (
                                        dat[filter.id] != null ? (
                                          jMoment(dat[filter.id], 'YYYY/M/D')
                                            .locale('fa')
                                            .format('jYY/jMM/jDD')
                                        ) : (
                                          '-'
                                        )
                                      ) : filter.type == 'checkbox' &&
                                        filter.checkbox ? (
                                        <FormControl style={{ width: '100%' }}>
                                          <Icon
                                            path={filter?.selectIcon}
                                            size={1}
                                            className={classes.changStatusIcon}
                                          />
                                          <Select
                                            className={classes.changStatusBox}
                                            fullWidth
                                            name={`status${index3}`}
                                            multiple
                                            id={dat.id}
                                            value={[{}]}
                                            IconComponent={() => null}
                                            renderValue={() => (
                                              <span
                                                className={classes.renderValue}
                                              >
                                                {fieldTranslator(
                                                  dat.status,
                                                  filter.translate
                                                )}
                                              </span>
                                            )}
                                          >
                                            <RadioGroup
                                              className={classes.radioGroup}
                                              aria-label={`status${index3}`}
                                              name={`status${index3}`}
                                              value={'item'}
                                              onChange={(
                                                e: React.ChangeEvent<{
                                                  value: unknown;
                                                }>
                                              ) =>
                                                props.changeStatus({
                                                  id: dat.id,
                                                  body: `"${e.target.value}"`,
                                                })
                                              }
                                            >
                                              {filter.statusType == 'Order'
                                                ? filter.statusModel[
                                                  dat.status
                                                ]?.map(
                                                  (
                                                    item: any,
                                                    index: number
                                                  ) => (
                                                    <FormControlLabel
                                                      className={
                                                        classes.radioGroupItem
                                                      }
                                                      key={index}
                                                      checked={
                                                        dat.status === item
                                                      }
                                                      value={item}
                                                      control={<Radio />}
                                                      label={fieldTranslator(
                                                        item,
                                                        filter.translate
                                                      )}
                                                    />
                                                  )
                                                )
                                                : filter.statusModel?.map(
                                                  (
                                                    item: any,
                                                    index: number
                                                  ) => (
                                                    <FormControlLabel
                                                      className={
                                                        classes.radioGroupItem
                                                      }
                                                      key={index}
                                                      checked={
                                                        dat.status === item
                                                      }
                                                      value={item}
                                                      control={<Radio />}
                                                      label={fieldTranslator(
                                                        item,
                                                        filter.translate
                                                      )}
                                                    />
                                                  )
                                                )}
                                            </RadioGroup>
                                          </Select>
                                        </FormControl>
                                      ) : filter.type == "time-picker" ? (
                                        <span>
                                          {jMoment(dat.deliveryStartTime, 'hh:mm')
                                            .locale('fa')
                                            .format('HH:mm')}
                                          {` - `}
                                          {jMoment(dat.deliveryEndTime, 'hh:mm')
                                            .locale('fa')
                                            .format('HH:mm')}
                                        </span>
                                      ) : filter.translate ? (
                                        translate(
                                          dat[filter.id],
                                          filter.translate
                                        )
                                      ) : dat['fulfillmentWarehouseName'] &&
                                        filter.id == 'centerName' ? (
                                        dat['fulfillmentWarehouseName']
                                      ) : dat['centerName'] &&
                                        filter.id == 'centerName' ? (
                                        dat['centerName']
                                      ) : dat[filter.id] != null ? (
                                        dat[filter.id]
                                      ) : (
                                        '-'
                                      )}
                                    </StyledTableCell>
                                  </Fragment>
                                );
                              }
                            )}
                            {props.children && (
                              <StyledTableCell>
                                {props.children(dat)}
                              </StyledTableCell>
                            )}
                          </TableRow>
                        );
                      })}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </div>
        </Grid>
        <Grid item xs={12} sm={6}>
          {props.data.length > 0 && (
            <FormControl
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <div style={{ marginLeft: '10px', color: '#8a8a8a' }}>
                {' '}
                تعداد نمایش در هر صفحه:
              </div>
              <Select
                open={openSize}
                onClose={pageSizeCloseHandler}
                onOpen={() => setOpenSize(true)}
                value={filtersValues.size}
                onChange={changeSizePageHandler}
              >
                <MenuItem value={10}>10</MenuItem>
                <MenuItem value={20}>20</MenuItem>
                <MenuItem value={50}>50</MenuItem>
                <MenuItem value={100}>100</MenuItem>
              </Select>
            </FormControl>
          )}
        </Grid>
        <Grid xs={12} sm={6} container item direction="row-reverse">
          {props.data.length > 0 && (
            <Pagination
              className={classes.pagination}
              count={Math.ceil(props.count / filtersValues.size)}
              color="secondary"
              page={filtersValues.page + 1}
              onChange={changePageHandler}
            />
          )}
        </Grid>
      </Grid>
    </StylesProvider>
  );
};
export default Helper;
